// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__ott6u","content":"LoadingAlert_content__3toxg"};